import { useEffect, useState, useRef } from "react"

// show refresh modal if timeout is reached on a non-dirty (unedited) form
const useTimer = ({ ms, isFormDirty, onTimeout }) => {
  const [dirty, setDirty] = useState(false)
  const timer = useRef(null)

  useEffect(() => {
    if (!ms || isNaN(ms) || isFormDirty) {
      // form made dirty, stop timer
      clearTimeout(timer.current)
      setDirty(isFormDirty)
      return
    }

    const startTimer = (ms) => {
      clearTimeout(timer.current)
      timer.current = setTimeout(() => {
        console.log(`Max time ${ms} ms reached`)
        // call function on timeout
        onTimeout()
      }, ms)
      return () => clearTimeout(timer.current)
    }

    if (!dirty) {
      // start timer
      startTimer(ms)
    }
  }, [ms, isFormDirty, dirty, onTimeout])
}

export default useTimer